import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  computed,
  ElementRef,
  inject,
  Inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '@app/core/services/api/api.service';
import { UtilService } from '@app/core/services/utils/util.service';
import { DeleteOrderDialogComponent } from '@app/sharedModule/components/delete-order-dialog/delete-order-dialog.component';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { CookieService } from 'ngx-cookie-service';
import { asyncScheduler, EMPTY, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, finalize, switchMap, takeUntil, tap, throttleTime } from 'rxjs/operators';
import {
  createStepFilter,
  formatBillTo,
  formatMultiParcelBoxName,
  formatShippingAddressString,
  formatShippingNameString,
  formattedDate,
  formattedServiceLevel,
  getDeliveryPromise,
  groupByValueFormatter,
  TABLES,
  TimeUnits,
  formatOrderRadius,
  initColumnsOptionsByShop,
  getAdditionalColumnsByShopMetadata,
  modifyDateRangeValuesByColumn,
} from 'src/utils';
import { DownloadorderdialogComponent } from '../../dialogs/downloadorderdialog/downloadorderdialog.component';
import { HolddialogComponent } from '../../dialogs/holddialog/holddialog.component';

import { DOCUMENT } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { FreeSearchParameters } from '@app/core/entities/free-search-parameters.class';
import { QueryPagingParameters } from '@app/core/entities/query-paging-parameters.class';
import { Filter, FilterTypes, QueryParameters, SortField } from '@app/core/entities/query-parameters.class';
import { EventService } from '@app/core/services/event/event.service';
import { OrderCounterTypes, WSEventData, WsRefreshRatesData } from '@app/core/services/web-socket/web-socket.model';
import { WebSocketService } from '@app/core/services/web-socket/web-socket.service';
import { WebsocketSubscriberService } from '@app/core/services/websocket-subscriber/websocket.subscriber.service';
import { EditOrderPackageComponent } from '@app/features/side-panel/components/order-details.component/components/order-package/edit-order-package/edit-order-package.component';
import { SidePanelService } from '@app/features/side-panel/side-panel.service';
import { AdvancedFilterService } from '@app/pages/workspace/assign/services/advanced-filter/advanced-filter.service';
import { AdvancedFiltersActions } from '@app/pages/workspace/assign/store/actions';
import { Order } from '@app/services/order/order.model';
import { OrderService } from '@app/services/order/order.service';
import { PrintService } from '@app/services/print/print.service';
import { Shop } from '@app/services/shops/shop.model';
import { ShopService } from '@app/services/shops/shop.service';
import { TableService } from '@app/services/table/table.service';
import { AddTagsComponent } from '@app/sharedModule/components/add-tags/add-tags.component';
import { ChangeLocationDialogComponent } from '@app/sharedModule/components/change-location-dialog/change-location-dialog.component';
import { NewuiSearchAutocompleteComponent } from '@app/sharedModule/components/newui-search-autocomplete/newui-search-autocomplete.component';
import { SplitOrderComponent } from '@app/sharedModule/components/split-order/split-order.component';
import {
  ColumnSettings,
  ColumnTypes,
  GroupAction,
  PaginationOptionsDisplay,
  RowAction,
  TableFilterType,
  tableMessages,
  ColumnName,
} from '@app/sharedModule/models/table-settings.model';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import { Store } from '@ngrx/store';
import { AssignToCarrier } from '@pages/workspace/assign/components/assign-to-carrier/assign-to-carrier';
import { ServiceLevelToDisplayName } from '@pdqdev/pdq-shared/dist/CarrierData';
import { GroupByOptions, OrderStatus, WeightUnitEnum } from '@pdqdev/pdq-shared/dist/entities';
import { IShopMetadata } from '@pdqdev/pdq-shared/dist/interfaces/IShopMetadata';
import { TranslatedFulfillmentStatus } from '@pdqdev/pdq-shared/dist/OrderData';
import { PdqToastComponent } from '@storybook/components/toast/toast.component';
import { ToastService } from '@storybook/services/toast/toast.service';
import moment from 'moment';

import { AdvancedFilter } from 'src/app/sharedModule/models/advanced-filter.model';
import { PrintDocumentType } from 'src/utils/print-utils';
import { getAdditionalGroupActionsByShop, getAdditionalRowActionsByShop } from '../../../../checkout-app/utils';
import { assignColumnsConfig } from '../../configs/table.config';
import { SnoozeComponent } from '../../dialogs/snooze/snooze.component';
import { AddFiltersService } from '../../services/add-filters.service';
import { AdvancedFiltersSelectors } from '../../store/selectors';
import { AdvancedFiltersComponent } from '../advanced-filters/advanced-filters.component';
import { compareArrays } from '@utils/array-utils';
import { UserService } from '@app/services/user/user.service';
import { getOrderSplitIndicesString } from '@utils/order-split-utils';
import { getDefaultSortField } from '@utils/shop-utils';
import { MergeOrdersComponent } from '@app/sharedModule/components/merge-orders/merge-orders.component';
import { SidePanelSection } from '@app/features/side-panel/utils/side-panel-sections.utils';
import { KeyShortCutService } from '@services/key-shortcut/key-shortcut.service';
import { OrdersInProcess } from '@pdqdev/pdq-shared/dist/interfaces';
import { BoxService } from '@services/boxes/box.service';
import { getBoxUpdateFailureMessage, getBoxUpdateSuccessMessage } from '@utils/parcel.utils';
import { ExportOptionType } from '@utils/export-utils';
import { assignColorCodingToRows } from '@utils/color-coding.utils';
import { DeliverCursorPaginationService } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.service';
import { DeliverCursorPagination } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.model';
import { AssignCursorPaginationService } from '../../services/assign-cursor-pagination.service';
import { PaginationCursorAction } from '@app/storybook/layouts/components/footer/pagination/pagination.component';

export const GROUP_BY_MAX_RESULTS = 200;

export type RowsGroup = {
  key: string;
  index: number;
  value: string;
  rows: Order[];
};

export const TabValueToOrderStatus = Object.freeze({
  [FilterTypes.READY]: OrderStatus.STEP_ASSIGN,
  [FilterTypes.HOLD]: OrderStatus.HOLD,
  [FilterTypes.SCHEDULE]: OrderStatus.SCHEDULED,
});
@Component({
  selector: 'app-assign-table',
  templateUrl: './assign-table.component.html',
  styleUrls: ['./assign-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  providers: [{ provide: DeliverCursorPaginationService, useClass: AssignCursorPaginationService }],
})
export class AssignTableComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('input') input: ElementRef;
  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent;
  @ViewChild(AdvancedFiltersComponent) advancedFiltersComponent: AdvancedFiltersComponent;
  @ViewChild(MatSelect) editcolumns: MatSelect;
  @ViewChild('searchAutocompleteRef')
  searchAutocompleteRef: NewuiSearchAutocompleteComponent;

  readonly TABLES = TABLES;
  readonly DEFAULT_ADVANCED_FILTER = 'ready';
  columnsOptions: ColumnSettings[] = assignColumnsConfig.filter(
    (column: ColumnSettings) => column.canBeHide && !column.displayCondition,
  );
  onUpdateAdvancedFilters: Subject<any> = new Subject<any>();
  advancedFilters$ = this.store.select(AdvancedFiltersSelectors.selectAdvancedFilters);
  freeSearchSubscription$: Subscription;
  filter: string | number = this.DEFAULT_ADVANCED_FILTER;
  tabFilter: string = FilterTypes.READY;
  mentionsFilter;
  filterActive = false;
  aFilter;
  countReadyOrders$ = this.store.select(AdvancedFiltersSelectors.selectCountReadyOrders);
  countHoldOrders$ = this.store.select(AdvancedFiltersSelectors.selectCountHoldOrders);
  countScheduleOrders$ = this.store.select(AdvancedFiltersSelectors.selectCountScheduleOrders);
  onChangeAdvancedFilter$: Subscription;
  onAdvancedFilter$: Subscription;
  filteredTags;
  columns: ColumnSettings[] = [...assignColumnsConfig];
  rowActions = [RowAction.RE_SYNC_ORDER, RowAction.DELETE_ORDER];
  groupActions: GroupAction[];

  sidePanelPrintActions = [
    PrintDocumentType.PACKING_SLIPS,
    PrintDocumentType.BROCHURE,
    PrintDocumentType.PICK_LIST,
    PrintDocumentType.CARD_ISLE,
  ];
  tablePrintActions = [
    PrintDocumentType.PICK_LIST,
    PrintDocumentType.PACKING_SLIPS,
    PrintDocumentType.BROCHURE,
    PrintDocumentType.CARD_ISLE,
  ];
  temp = [];
  rows = [];
  totalCountOrders: number;
  ordersPerPage = 50;
  allPages = {};
  activePage = 1;
  totalPages = 1;
  perPageOptions = [...PaginationOptionsDisplay];
  selectedColumns: string[];
  notshow = true;
  unhold = false;
  unschedule = false;
  ready: any;
  schedule: any;
  editcolumnsPannel = false;
  selected = [];
  rowSelectOptions = [];
  showHeaderAction = false;
  showHeaderLower = true;
  showAssignCarrier = false;
  freeSearchInputControl = new UntypedFormControl();
  showFreeSearchSuggestions = false;
  showFreeSearchClearButton = false;
  freeSearchValue: any = '';
  freeSearchSelectedField = 'orderNumber';
  searchResults = [];
  loading = false;
  isAdvancedFilters: boolean = false;
  searchtogglebuttons = false;
  isSyncing = false;
  options = { checkboxes: true };
  columnsFilter: any = {};
  virtualizeGroupBy = computed(
    () =>
      !!this.shopService.shopSignal().metadata?.virtualizeGroupBy ||
      !!this.activatedRoute.snapshot.queryParams['virtualizeGroupBy'],
  );
  deliverCursorPagination = inject(DeliverCursorPaginationService) as DeliverCursorPaginationService<
    DeliverCursorPagination.AssignTabCounters,
    DeliverCursorPagination.AssignTabCountersPayload
  >;
  useCursorPagination = this.deliverCursorPagination.useCursorPagination;
  cappedReadyLabel = computed(() => this.getCappedCounterLabel(FilterTypes.LABEL_READY, 'ready'));
  cappedHoldLabel = computed(() => this.getCappedCounterLabel(FilterTypes.LABEL_PAUSE, 'hold'));
  cappedScheduledLabel = computed(() => this.getCappedCounterLabel(FilterTypes.LABEL_SNOOZE, 'scheduled'));
  private destroyed$: Subject<any> = new Subject();
  readonly FilterTypes = FilterTypes;
  isBottomScrolled: boolean = false;
  focusedOrderId: string | null = null;
  readonly GroupByOptions = GroupByOptions;
  private shopMetadata: IShopMetadata | any;
  private setAssignCountersSubscription$: Subscription;
  private queryParamsSubscription$: Subscription;
  private sortFields: SortField[] | 'NONE';
  private tableFilters: Filter[];
  private orderIdSearchParams: string = null;
  private readonly emitTimeoutMS = 5000;
  private advancedFiltersSubject = new Subject<any>();
  private shop: Shop;
  isOrdersUpdating;
  disableGroupActions;
  shopLocations;
  groupBy = [];
  groupRowsBy;

  groupNextCheckedMap: Record<
    'selected' | 'unselected' | 'indeterminate',
    'selected' | 'unselected' | 'indeterminate'
  > = {
    unselected: 'selected',
    selected: 'unselected',
    indeterminate: 'unselected',
  };

  groupedRowsMap = signal<Record<string, RowsGroup>>({});
  groupedRows = computed(() => Object.values(this.groupedRowsMap()));
  groupCollapseState = signal<Record<string, boolean>>({});
  groupCheckedState = signal<
    Record<
      string,
      {
        checked: boolean;
        checkVariant: 'hyper' | 'indeterminate';
        selectionState: 'selected' | 'unselected' | 'indeterminate';
      }
    >
  >({});
  groupVisibilityState = signal<Record<string, boolean>>({});
  tableHorizontalScrollPosition = signal<number>(0);
  displayTable = true;
  shopId;
  isShopInTrialMode: boolean;
  shopBoxes;
  isLoadedInitialData = false;
  screenTitle = 'Assign for delivery';
  isPickingMode: boolean = false;
  shortcutScope = 'assign-table';
  keyboardShortcuts = [];

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public dialog: MatDialog,
    public apiService: ApiService,
    private advancedFilterService: AdvancedFilterService,
    private orderService: OrderService,
    public utilService: UtilService,
    private cookieService: CookieService,
    private formBuilder: UntypedFormBuilder,
    private store: Store,
    private wsService: WebSocketService,
    private advancedFiltersEventService: AddFiltersService,
    private wsSubscriber: WebsocketSubscriberService,
    private eventService: EventService,
    private shopService: ShopService,
    private route: ActivatedRoute,
    private spService: SidePanelService,
    private toastService: ToastService,
    private tableService: TableService,
    private cdr: ChangeDetectorRef,
    private _printService: PrintService,
    private userService: UserService,
    private shortCutService: KeyShortCutService,
    private boxService: BoxService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.initAdvancedFilters();
  }

  async ngOnInit(): Promise<void> {
    this.initGroupActions();
    this.initShopService();
    this.loadLocalStorageDefaultColumns();
    this.initSidePanelService();
    this.initTableService();
    this.initAssignActionsListener();
    this.initGetAdvancedFiltersQuery();
    this.initRatesChanges();
    this.initShortcuts();
    this.initOrdersInProcess();
  }

  initGroupActions() {
    const currentUserRole: any = this.userService.currentMeUser?.roles;
    this.groupActions = [
      GroupAction.HOLD_ORDERS,
      GroupAction.SCHEDULE_ORDERS,
      GroupAction.EXPORT_ORDERS,
      GroupAction.DELETE_ORDERS,
      GroupAction.UNHOLD_ORDERS,
      GroupAction.UNSCHEDULE_ORDERS,
      GroupAction.PACKING_SLIPS,
      GroupAction.PICK_LIST,
      GroupAction.COLOR_CODING,
      GroupAction.SHIPMENT_EXTRAS,
    ];
    if (!currentUserRole?.includes('WRITE_NO_TAGS')) {
      this.groupActions.push(GroupAction.TAG_ORDERS);
    }
    this.groupActions.push(GroupAction.TEAM_NOTE, GroupAction.RE_SYNC_ORDERS, GroupAction.SHIPMENT_PREFERENCES);
  }

  initShopService(): void {
    this.shopService.shop$.pipe(takeUntil(this.destroyed$)).subscribe((shop) => {
      this.shop = shop;
      this.shopMetadata = shop?.metadata;
      if (this.shopMetadata?.addOptionPerPage) {
        this.perPageOptions.push({
          value: this.shopMetadata.addOptionPerPage,
          text: `${this.shopMetadata.addOptionPerPage} per page`,
        });
      }
      this.ordersPerPage = this.orderService.getOrderPerPage('assign_orderperpage_cookie');
      if (!this.perPageOptions.find((option) => option.value === this.ordersPerPage)) {
        this.ordersPerPage = this.orderService.getOrderPerPage('orderperpage_cookie');
      }
      this.getPagedOrders(0, true);
      this.shopId = shop?.id;
      this.isShopInTrialMode = shop?.isOnTrialPlan;
      this.shopLocations = shop?.shopLocations;

      const additionalGroupActions = getAdditionalGroupActionsByShop(shop);
      const additionalRowActions = getAdditionalRowActionsByShop(shop);

      this.groupActions = Array.from(new Set([...this.groupActions, ...additionalGroupActions]));
      this.rowActions = Array.from(new Set([...this.rowActions, ...additionalRowActions]));
      this.adjustColumns(shop);
      this.isPickingMode = this.shopMetadata?.pickingModeInAssign;
      this.cdr.detectChanges();
    });

    this.shopService.shopDefaultBoxes$.pipe(takeUntil(this.destroyed$)).subscribe(({ activeBoxes, inactiveBoxes }) => {
      this.shopBoxes = [...activeBoxes];

      this.keyboardShortcuts = this.boxService.getBoxKeyboardShortcuts(this.shopBoxes);
    });
  }

  initOrdersInProcess() {
    this.wsSubscriber
      .fireOrdersInProcess()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((res: OrdersInProcess) => {
        if (res.orders?.length) {
          res.orders.forEach((order: any) => {
            this.tableService.ordersInProcessMap.set(order.id, order.inProcess);
          });
          this.refreshCurrentPage();
        }
      });
  }

  adjustColumns(shop: Shop) {
    const additionalColumnsByShopMetadata = getAdditionalColumnsByShopMetadata(assignColumnsConfig, shop);
    this.columnsOptions = [...new Set([...this.columnsOptions, ...additionalColumnsByShopMetadata])];

    this.columns = initColumnsOptionsByShop(
      this.columns,
      shop,
      [ColumnName.INVENTORY_LOCATION],
      this.apiService.userLocationIds,
    );
    const flagWeightInAssign = !!this.shopMetadata?.flagWeightInAssign;
    const flagPackageInAssign = !!this.shopMetadata?.flagPackageInAssign;
    if (flagWeightInAssign || flagPackageInAssign) {
      const checkBoxColumn = this.columns.find((column) => column.prop == 'checkbox');
      checkBoxColumn.width = 70;
      checkBoxColumn.minWidth = 70;
      checkBoxColumn.maxWidth = 70;
      this.cdr.detectChanges();
    }
  }

  initTableService(): void {
    this.tableService.onRefreshTableOrders$.pipe(takeUntil(this.destroyed$)).subscribe((orders) => {
      orders.forEach((order) => {
        this.rows.find((o, index) => {
          if (o.id === order.id) {
            this.rows[index] = { ...this.rows[index], ...order };
          }
        });
      });
      this.temp = [...this.rows];
    });

    this.tableService.popoverPressedRowId$.pipe(takeUntil(this.destroyed$)).subscribe((rowId) => {
      this.focusedOrderId = rowId;
    });
  }

  initSidePanelService(): void {
    this.spService.focusedOrderId$.pipe(takeUntil(this.destroyed$)).subscribe(({ focusedId }) => {
      this.focusedOrderId = focusedId ?? null;
    });
  }

  queryParamsOrderJump(): void {
    this.queryParamsSubscription$ = this.route.queryParams
      .pipe(takeUntil(this.destroyed$))
      .subscribe((queryParam: any) => {
        this.orderIdSearchParams = queryParam.search;
        if (this.orderIdSearchParams) {
          this.filter = FilterTypes.QUERY_PARAMS;
          this.getPagedOrders(0, true);
        }
      });
  }

  initAssignActionsListener() {
    // we want to separate web socket update events, paused,snoozed,deleted,assign to carrier and other external updates
    this.wsSubscriber
      .fireAssignScreenActionsChanges()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data: WSEventData) => {
        this.tableService.clearOrderCachedMap();
        if (this.apiService.userLocationIds?.length) {
          this.calculateLimitedOrdersAndCounts(data);
        } else {
          this.setCountersAndOrders(data);
        }
      });
  }

  detectChildChanges() {
    this.cdr.detectChanges();
  }

  setAssignCounters(): void {
    this.setAssignCountersSubscription$ = this.wsSubscriber
      .fireAssignOrdersCounterChanged()
      .pipe(
        throttleTime(this.emitTimeoutMS, asyncScheduler, { leading: true, trailing: true }),
        takeUntil(this.destroyed$),
      )
      .subscribe((data: WSEventData) => {
        // reset all cached orders, until we push updated orders to frontend
        this.tableService.clearOrderCachedMap();
        if (this.apiService.userLocationIds?.length) {
          this.calculateLimitedOrdersAndCounts(data);
        } else {
          this.setCountersAndOrders(data);
        }
      });
  }

  setCountersAndOrders(data: Partial<WSEventData>) {
    if (this.useCursorPagination()) {
      const toCapped = (value: number) => this.deliverCursorPagination.toCappedCount(value ?? 0, TABLES.ASSIGN);
      this.deliverCursorPagination.updateTabCounters({
        ready: toCapped(data.readyCount),
        hold: toCapped(data.holdCount),
        scheduled: toCapped(data.scheduledCount),
      });
    } else {
      this.store.dispatch(
        AdvancedFiltersActions.changeCountReadyOrders({
          countReadyOrders: data.readyCount,
        }),
      );
      this.store.dispatch(
        AdvancedFiltersActions.changeCountHoldOrders({
          countHoldOrders: data.holdCount,
        }),
      );
      this.store.dispatch(
        AdvancedFiltersActions.changeCountScheduleOrders({
          countScheduleOrders: data.scheduledCount,
        }),
      );
    }
    this.refreshCurrentPage();
  }

  initRatesChanges() {
    this.wsSubscriber
      .fireRefreshRates()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data: WsRefreshRatesData) => {
        if (data?.orderId && data.selectedRate) {
          const orderIndex = this.rows.findIndex((o) => o.id === data.orderId);
          if (orderIndex !== -1) {
            this.rows[orderIndex].selectedRate = data.selectedRate;
            this.temp = [...this.rows];
            this.cdr.detectChanges();
          }
        }
      });
  }

  refreshAdvancedFilters() {
    this.store.dispatch(AdvancedFiltersActions.refreshAdvancedFilters());
  }

  loadCountHoldOrders(): void {
    this.store.dispatch(AdvancedFiltersActions.loadCountHoldOrders());
  }

  loadCountReadyOrders(): void {
    this.store.dispatch(AdvancedFiltersActions.loadCountReadyOrders());
  }

  loadCountScheduleOrders(): void {
    this.store.dispatch(AdvancedFiltersActions.loadCountScheduleOrders());
  }

  advancedFilterListeners(): void {
    this.onAdvancedFilter$ = this.advancedFiltersEventService
      .advancedFilterListener()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.store.dispatch(AdvancedFiltersActions.refreshAdvancedFilters());
      });

    this.onChangeAdvancedFilter$ = this.advancedFiltersEventService
      .changeFilterListener()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((event) => {
        this.onChangeFilter(event);
      });
  }

  calculateLimitedOrdersAndCounts(data: WSEventData) {
    const isCountAdjustToUser = _.isEqual(this.apiService.userLocationIds, data.userLocationCounters?.locationIds);
    if (isCountAdjustToUser) {
      const counters = isCountAdjustToUser && data.userLocationCounters;
      this.setCountersAndOrders(counters);
    } else {
      this.orderService.getAllCounters(OrderCounterTypes.ASSIGN_PAGE).then((data) => {
        if (!data.userLocationCounters) return;
        const counters = data.userLocationCounters;
        this.setCountersAndOrders(counters);
      });
    }
  }

  onChangeFilter(event: string | AdvancedFilter | any): void {
    // reset search input
    this.searchAutocompleteRef?.resetFormControl();

    this.unSelectOrders();
    if (typeof event === 'string' || typeof event.value === 'string') {
      if ([FilterTypes.READY, FilterTypes.HOLD, FilterTypes.SCHEDULE].includes(event)) {
        this.tabFilter = event;
        this.cdr.detectChanges();
        this.searchAutocompleteRef?.defineStepFilter();
      }
      this.isAdvancedFilters = false;
      this.filter = event.value ?? event;
      this.aFilter = null;
      this.advancedFiltersComponent?.resetSelectedFilters();
      this.groupBy = [];
      this.groupedRowsMap.set({});
      this.groupVisibilityState.set({});
    } else {
      this.aFilter = event;
      event.some((value) => !!value.id) ? (this.isAdvancedFilters = true) : (this.isAdvancedFilters = false);
    }

    if (this.isAdvancedFilters) {
      this.setAssignCountersSubscription$?.unsubscribe();
      this.setAssignCountersSubscription$ = null;
    } else if (!this.setAssignCountersSubscription$) {
      this.setAssignCounters();
    }

    this.activePage = 1;
    this.getPagedOrders(0);
  }

  onMentionFilterChanged(mentions) {
    if (compareArrays(mentions, this.mentionsFilter)) return;

    // reset search input
    this.searchAutocompleteRef?.resetFormControl();

    this.mentionsFilter = mentions;

    this.activePage = 1;
    this.getPagedOrders(0);
  }

  toClearAdvancedFilters(event) {
    this.unSelectOrders();

    this.isAdvancedFilters = false;
    this.aFilter = null;
    this.getPagedOrders(this.activePage - 1);
  }

  bulkChangeColorCoding({ orderColors }: { orderColors: Pick<Order, 'id' | 'colorCoding'>[] }) {
    const previousRows = this.rows;
    this.assignColorsCodingUpdate(orderColors);
    this.orderService
      .updateOrdersColorCodingV2(orderColors)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        error: (error) => {
          this.assignColorsCodingUpdate(previousRows);
          this.toastService.showToast({
            message: `Failed to update color coding`,
            mode: 'danger',
          });
        },
      });
  }

  sortColumns(sortOptions): void {
    this.columns = this.columns.map((column: ColumnSettings, i: number) => {
      if (i !== sortOptions.index) {
        return { ...column, sortDirection: null };
      }

      const sortDirection = sortOptions.sortDirection;
      const sortFieldNames: string[] = column.sortFieldName ? column.sortFieldName : [column.prop];

      this.sortFields = sortFieldNames.map((fieldName: string) => new SortField(fieldName, sortDirection));

      return {
        ...column,
        sortDirection,
      };
    });

    this.getPagedOrders(this.activePage - 1);
  }

  onCollapseGroupChanged(collapsed: boolean, group: RowsGroup): void {
    this.groupCollapseState.update((prev) => ({ ...prev, [group.key]: collapsed }));
  }

  onGroupVisibilityChanged(isVisible: boolean, groupKey: string): void {
    // Batch update without triggering immediate change detection
    const currentState = this.groupVisibilityState();
    if (currentState[groupKey] !== isVisible) {
      this.groupVisibilityState.update((prev) => ({ ...prev, [groupKey]: isVisible }));
      // Mark for check instead of immediate detection
      this.cdr.markForCheck();
    }
  }

  onChangeTableFilter(columnIndex: number): void {
    this.tableFilters = [];
    this.sortFields = undefined;
    let fieldName;
    this.columns.forEach((column: ColumnSettings) => {
      if (!column.filterType || !column.filterOption || (!column.filterValue && !column.filterValueArray?.length)) {
        return;
      }
      fieldName = column.filterFields ? column.filterFields : column.prop;
      let filterValue = [column.filterValue];

      if (column.filterType === TableFilterType.COLOR) {
        filterValue = column.filterValueArray;
      } else if (column.filterOption === 'DATE RANGE' || column.filterOption === 'DATE RANGE STRICT') {
        filterValue = [];
        if (column.filterValueStart) {
          filterValue.push(column.filterValueStart);
        }
        if (column.filterValueEnd) {
          const endDate = new Date(Date.parse(column.filterValueEnd));
          endDate.setDate(endDate.getDate() + 1);
          modifyDateRangeValuesByColumn(column.prop, { endDate: endDate });
          filterValue.push(endDate.toISOString());
        }
      } else if (column.filterOption === 'LIKE' && !this.shopMetadata?.applySortingOnFilters) {
        // if we have to add a sort field in the future, consider use id instead of createdDate for better performance
        this.sortFields = 'NONE';
      }

      if (column.prop === 'time_since_ordered') {
        filterValue = [];
        const date = new Date();
        // 2021-03-31T21:00:00.000Z
        if (column.filterValue === '> 5') {
          date.setDate(date.getDate() - 5);
          filterValue.push(moment(new Date(0)).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'z');
          filterValue.push(moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'z');
        } else if (column.filterValue === '> 10') {
          date.setDate(date.getDate() - 10);
          filterValue.push(moment(new Date(0)).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'z');
          filterValue.push(moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'z');
        } else if (column.filterValue === '> 15') {
          date.setDate(date.getDate() - 15);
          filterValue.push(moment(new Date(0)).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'z');
          filterValue.push(moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'z');
        } else {
          date.setDate(date.getDate() - Number(column.filterValue));
          filterValue.push(moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'z');
          filterValue.push(moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'z');
        }
      }
      if (column.filterType !== TableFilterType.TAGS && column.type !== ColumnTypes.PACKAGES) {
        this.tableFilters.push(
          new Filter(
            fieldName,
            column.filterOption,
            filterValue.map((x) => (x?.trim ? x.trim() : x)),
          ),
        );
      }

      if (column.filterType === TableFilterType.TAGS && column.filterValueArray?.length > 0) {
        column.filterValueArray.forEach((filterValue) => {
          this.tableFilters.push(new Filter(filterValue.type, column.filterOption, [filterValue.name]));
        });
      }

      if (column.type === ColumnTypes.PACKAGES) {
        const options: any = {};
        if (this.shopMetadata?.isMultiParcelSupport) {
          options.isMultiParcel = true;
        }
        this.tableFilters.push(new Filter(fieldName, column.filterOption, filterValue, options));
      }
    });

    this.filterActive = fieldName ? true : false;
    this.activePage = 1;
    this.getPagedOrders(this.activePage - 1);
  }

  async onTableActivate({ row }) {
    if (!row.id) {
      return;
    }

    this.spService.setFocusedOrderId(row.id);
  }

  openedChange(event) {
    event.stopPropagation();
  }

  onSearchToTable(event: { filter: string; searchTerm: string | number; searchField: string }): void {
    this.freeSearchValue = event.searchTerm;
    this.filter = event.filter;
    this.freeSearchSelectedField = event.searchField;
    this.activePage = 1;
    this.getPagedOrders(0, false, true, true);
  }

  getPagedOrders(page, ignoreRatelLimit: boolean = false, status = true, toOpenSidePanel: boolean = false): void {
    if (this.useCursorPagination()) {
      this.pullOrdersByCursor(page === 0 ? 'first' : 'current', toOpenSidePanel);
      return;
    }

    this.loading = true;
    const queryParameters = this.sortFields?.length
      ? this.createQueryParameters(page, this.sortFields)
      : this.createQueryParameters(page);

    if (ignoreRatelLimit) {
      queryParameters.ignoreRateLimit = true;
    }

    if (this.tableFilters?.length) {
      queryParameters.filters = [...queryParameters.filters, ...this.tableFilters];
    }

    this.notshow = true;
    this.unhold = false;
    this.unschedule = false;

    switch (this.filter) {
      case FilterTypes.QUERY_PARAMS: {
        // If we fetch a speicific order, remove all other filters
        queryParameters.filters = [new Filter('order.id', 'EQUAL', [this.orderIdSearchParams])];
        queryParameters.stepFilter = undefined;
        break;
      }
      case FilterTypes.SCHEDULE: {
        this.groupBy = [];
        this.groupedRowsMap.set({});
        this.groupVisibilityState.set({});
        // this.displayTable = false;
        this.notshow = false;
        this.unschedule = true;
        this.unhold = false;
        if (this.isAdvancedFilters) {
          break;
        }
        // const queryParameters = this.createQueryParameters(page);
        this.orderService
          .getAllScheduledOrders(queryParameters)
          .pipe(
            takeUntil(this.destroyed$),
            finalize(() => {
              this.loading = false;
              // this.displayTable = true;
            }),
          )
          .subscribe((data: { orders: Order[]; count: number }) => {
            this.processOrders(data);
          });
        return;
      }

      case FilterTypes.HOLD: {
        this.groupBy = [];
        this.groupedRowsMap.set({});
        this.groupVisibilityState.set({});
        // this.displayTable = false;
        this.notshow = false;
        this.unhold = true;
        this.unschedule = false;
        if (this.isAdvancedFilters) {
          break;
        }
        this.orderService
          .getAllHoldOrders(queryParameters)
          .pipe(
            takeUntil(this.destroyed$),
            finalize(() => {
              this.loading = false;
              // this.displayTable = true;
            }),
          )
          .subscribe((data) => {
            this.processOrders(data);
          });
        return;
      }

      // case FilterTypes.READY: {
      //   queryParameters.filters.push(new Filter('orderStatus', 'IN', [OrderStatus.STEP_ASSIGN]));
      //   break;
      // }

      case FilterTypes.FREE_SEARCH: {
        queryParameters.filters = [];
        const filter = this.getFreeSearchFilter();
        queryParameters.filters = [filter];
        break;
      }

      case FilterTypes.FREE_TEXT: {
        queryParameters.search = this.freeSearchValue;
        break;
      }

      case FilterTypes.MULTIPLE: {
        queryParameters.filters = [];
        const filter: Filter = new Filter(this.freeSearchSelectedField, 'IN', this.freeSearchValue);
        queryParameters.filters = [filter];
      }
    }

    if (this.mentionsFilter?.length) {
      const filter = new Filter('teamNotes.userCollaboration', 'IN', this.mentionsFilter);
      queryParameters.mentionsFilter = filter;
    }

    if (!this.isAdvancedFilters && status) {
      this.orderService
        .getOrdersObs(queryParameters)
        .pipe(
          takeUntil(this.destroyed$),
          finalize(() => {
            this.loading = false;
            this.isLoadedInitialData = true;
          }),
        )
        .subscribe((data: { orders: Order[]; count: number }) => {
          this.processOrders(data);
          if (this.isPickingMode && toOpenSidePanel && data.count === 1) {
            this.spService.setFocusedOrderId(this.rows[0].id, {
              sectionId: SidePanelSection.ORDER_ITEMS_WRAPPER,
              data: { action: 'edit' },
            });
          }
        });
    }

    if (this.aFilter && this.isAdvancedFilters) {
      const advancedFilterIds: string[] = [];
      this.aFilter.map((filter) => advancedFilterIds.push(filter.id));
      const queryPagingParameters = this.sortFields?.length
        ? this.createQueryPagingParameters(page, this.sortFields)
        : this.createQueryPagingParameters(page);

      const advancedFiltersParams = {
        advancedFilterIds,
        queryPagingParameters,
        tableFilters: queryParameters?.filters,
        stepFilter: queryParameters?.stepFilter,
      };
      this.advancedFiltersSubject.next(advancedFiltersParams);
    }
  }

  initGetAdvancedFiltersQuery() {
    let filterIds = null;
    this.advancedFiltersSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap(() => (this.loading = true)),
        debounceTime(300),
        switchMap((params: any) => {
          filterIds = params.advancedFilterIds;
          return this.orderService.getAdvancedFilterQuery(params).pipe(
            catchError((error) => {
              this.loading = false;
              this.toastService.showToast({
                message: error?.error,
                mode: 'danger',
              });
              return of();
            }),
          );
        }),
      )
      .subscribe(
        (data: { orders: Order[]; count: number }) => {
          this.loading = false;
          this.processOrders(data);
          filterIds?.map((filter) => {
            this.store.dispatch(
              AdvancedFiltersActions.changeCountOrderInFilter({
                filterId: +filter,
                countOrder: data?.count,
              }),
            );
          });
        },
        (error) => (this.loading = false),
      );
  }

  getFreeSearchFilter(): Filter {
    return new Filter(this.freeSearchSelectedField, 'IN', [this.freeSearchValue]);
  }

  clearFreeSearchFilter(): void {
    this.isAdvancedFilters = false;
    this.showFreeSearchSuggestions = false;
    this.searchtogglebuttons = false;
    this.freeSearchValue = '';
    this.filter = FilterTypes.READY;
    this.activePage = 1;
    this.getPagedOrders(0);
  }

  showFreeSearchResults(value: string): void {
    this.isAdvancedFilters = false;
    this.showFreeSearchSuggestions = false;
    this.filter = FilterTypes.FREE_SEARCH;
    this.freeSearchValue = value;
    this.activePage = 1;
    this.getPagedOrders(0);
  }

  // Calls a freetext query on the selected field from the searchbox (as opposed to clicking a suggestion - which calls a filter query)
  showFreeTextSearchResults(): void {
    this.isAdvancedFilters = false;
    this.showFreeSearchSuggestions = false;
    this.filter = FilterTypes.FREE_TEXT;
    this.activePage = 1;
    this.getPagedOrders(0);
  }

  changeFreeSearchField(event): void {
    this.freeSearchInputControl.setValue(this.freeSearchValue);
  }

  getFreeSearchSuggestions(event): Observable<any[]> {
    if (event.length === 0) {
      this.showFreeSearchClearButton = false;
      this.searchtogglebuttons = false;
      this.showFreeSearchSuggestions = false;
      return EMPTY;
    }

    this.showFreeSearchClearButton = true;
    this.showFreeSearchSuggestions = true;
    this.searchtogglebuttons = true;
    return this.orderService.getSearchOrders(
      new FreeSearchParameters(
        this.freeSearchValue,
        [this.freeSearchSelectedField],
        createStepFilter(TabValueToOrderStatus[this.tabFilter] ?? OrderStatus.STEP_ASSIGN),
      ),
    ) as Observable<any[]>;
  }

  ngAfterViewInit(): void {
    // freesearch server-side autocomplete
    this.freeSearchSubscription$ = this.freeSearchInputControl.valueChanges
      .pipe(
        debounceTime(300),
        switchMap((value) => this.getFreeSearchSuggestions(value)),
        takeUntil(this.destroyed$),
      )
      .subscribe((data) => {
        this.searchResults = data;
        this.showFreeSearchSuggestions = this.searchResults.length > 0;
      });

    this.editcolumns?.openedChange.pipe(takeUntil(this.destroyed$)).subscribe((isOpen) => {
      this.editcolumnsPannel = !!isOpen;
    });
  }

  openDialog(): void {
    let dialogRef;
    let additionalName;
    if (this.aFilter?.length) {
      additionalName = this.aFilter?.map((x) => x.name).join(' & ');
    } else if (this.groupBy.length) {
      additionalName = [...new Set(this.selected.map((item) => item.groupBy))]
        .map((x) =>
          x
            .split('~')
            .filter((x) => x)
            .join(' & '),
        )
        .join(' & ');
    }

    dialogRef = this.dialog.open(AssignToCarrier, {
      disableClose: true,
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '88vh',
      height: '88vh',
      backdropClass: '',
      panelClass: 'assign-table-dialog',
      data: {
        selected: this.selected,
        additionalName,
      },
      position: { bottom: '0%' },
    });

    // detach this component from change detection cycle when assign to carrier dialog is on
    this.cdr.detach();

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result) => {
        if (!result?.saveSelectedOrders) {
          this.unSelectOrders();
        }
        // reattach this comp to change detection cycle
        this.cdr.reattach();
        if (this.groupBy?.length) {
          this.refreshCurrentPage();
        }
      });
  }

  //actions like: hold, unhold, schedule
  toSelectedOrderActions(object: any): void {
    object?.row ? (this.selected = [object?.row]) : this.selected;
    const state: string = object?.event;
    const preText: string = object?.preText;
    const postText: string = this.selected?.length < 2 ? object?.postText : object?.multiplePostText;
    const dontDisplayOrderNumbers: boolean = object?.dontDisplayOrderNumbers;
    const dialogRef = this.dialog.open(HolddialogComponent, {
      maxWidth: '100vw',
      width: '28vw',
      panelClass: 'hold_popup',
      backdropClass: 'global_modal_overlay',
      disableClose: true,
      data: {
        rows: this.selected,
        state,
        preText,
        postText,
        dontDisplayOrderNumbers,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((snackbar) => {
        if (snackbar) {
          this.showSnackbar(snackbar.message, snackbar.mode);
        }
        this.unSelectOrders();
      });
  }

  //this function for selected rows or single row for

  toScheduleSelectedOrders(): void {
    const dialogRef = this.dialog.open(SnoozeComponent, {
      height: '246px',
      width: '425px',
      panelClass: 'schedule_popup',
      backdropClass: 'global_modal_overlay',
      data: this.selected.map((order) => order.id),
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.unSelectOrders();
      });
  }

  exportSelectedOrders({ option }: { option: ExportOptionType }): void {
    const dialogRef = this.dialog.open(DownloadorderdialogComponent, {
      maxWidth: '100vw',
      width: '35vw',
      panelClass: 'exportorders_popup',
      backdropClass: 'global_modal_overlay',
      data: {
        option,
        selectedOrders: this.selected,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        console.log('The dialog was closed');
      });
  }

  onBulkPrint(action): void {
    const fromAssign = true;
    const ids = this.selected.map((order) => order.id);
    this._printService.printOrder(action, ids, fromAssign);
  }

  onDeleteSelectedOrders(): void {
    const dialogRef = this.dialog.open(DeleteOrderDialogComponent, {
      width: '612px',
      disableClose: true,
      data: {
        rows: this.selected,
        table: TABLES.ASSIGN,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.unSelectOrders();
      });
  }

  onDeleteOrder(order: Order): void {
    const dialogRef = this.dialog.open(DeleteOrderDialogComponent, {
      width: '612px',
      disableClose: true,
      data: {
        rows: [order],
        table: TABLES.ASSIGN,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.unSelectOrders();
      });
  }

  calculateGroups(): void {
    this.rowSelectOptions.push([
      { label: '1-3', min: 0, max: 3 },
      { label: '4-6', min: 3, max: 6 },
      { label: '7-10', min: 6, max: 10 },
      { label: '> 10', min: 10, max: 9999 },
    ]);
  }

  onSelect(selectedOrders: Order[]): void {
    this.selected = [...selectedOrders];
    if (this.selected.length > 0) {
      this.showHeaderLower = false;
      this.showHeaderAction = true;
      this.showAssignCarrier = true;
      this.shortCutService.setScope(this.shortcutScope);
    } else {
      this.showHeaderLower = true;
      this.showHeaderAction = false;
      this.showAssignCarrier = false;
      this.shortCutService.revertScope(this.shortcutScope);
    }

    this.updateGroupedRowsCheckedState();
  }

  onGroupSelect(value: boolean, group: RowsGroup): void {
    const currentValue = this.groupCheckedState()[group.key].selectionState;
    const nextState = this.groupNextCheckedMap[currentValue];
    if (nextState === 'unselected') {
      this.unSelectOrders(group.rows);
    } else {
      const selectedRows = group.rows;
      const currentSelected = this.selected;
      const newSelected = [...currentSelected, ...selectedRows];
      this.onSelect(newSelected);
    }
  }

  convertToDayHour(timeStamp: number): string {
    const days = Math.floor(timeStamp / 1000 / 60 / 60 / 24);
    const hours = Math.floor(timeStamp / 1000 / 60 / 60 - days * 24);
    if (days == 0) {
      return `${hours} ${hours == 1 ? 'hour' : 'hours'}`;
    }
    return days + ` ${days == 1 ? 'day' : 'days'}, ` + hours + ` ${hours == 1 ? 'hour' : 'hours'}`;
  }

  unSelectOrders(unselectedOrders?: Order[]): void {
    if (unselectedOrders) {
      const unselectedIds = new Set(unselectedOrders.map((o) => o.id));
      this.selected = this.selected.filter((order) => !unselectedIds.has(order.id));
    } else {
      this.selected = [];
    }
    if (this.selected.length === 0) {
      this.showAssignCarrier = false;
      this.showHeaderLower = true;
      this.showHeaderAction = false;
    }

    this.updateGroupedRowsCheckedState();
  }

  updateGroupedRowsCheckedState(): void {
    if (!this.virtualizeGroupBy()) {
      return;
    }
    const selectedIds = new Set(this.selected.map((o) => o.id));
    const currentGroupCheckedState = this.groupCheckedState();

    Object.entries(currentGroupCheckedState).forEach(([key, value]) => {
      const currentGroups = this.groupedRowsMap();
      const rows = currentGroups[key]?.rows;
      if (!rows) {
        return;
      }

      const allSelected = rows.every((row) => selectedIds.has(row.id));
      const someSelected = !allSelected && rows.some((row) => selectedIds.has(row.id));
      currentGroupCheckedState[key].checked = allSelected || someSelected;
      currentGroupCheckedState[key].checkVariant = someSelected ? 'indeterminate' : 'hyper';
      currentGroupCheckedState[key].selectionState = allSelected
        ? 'selected'
        : someSelected
          ? 'indeterminate'
          : 'unselected';
    });
    this.groupCheckedState.set(currentGroupCheckedState);
  }

  loadDefaultPackagesOptions(index: number): void {
    this.shopService.shopDefaultBoxes$.pipe(takeUntil(this.destroyed$)).subscribe(({ activeBoxes, inactiveBoxes }) => {
      const boxes = [...activeBoxes];
      const boxOptions = [];
      let customOption;
      boxes?.forEach((box) => {
        const res = {
          value: box.name.toLowerCase(),
          text: box.name,
        };
        if (box.isCustom) {
          customOption = res;
        } else {
          boxOptions.push(res);
        }
      });
      if (customOption) boxOptions.push(customOption);
      this.columns[index].filterSelectOptions = boxOptions;
    });
  }

  loadLocalStorageDefaultColumns(): void {
    const data = localStorage.getItem('assign-columns');
    this.selectedColumns = data
      ? JSON.parse(data)
      : this.columnsOptions
          .filter((column: ColumnSettings) => !column.canBeHide || column.default)
          .map((column: ColumnSettings) => column.prop);
    this.loadSelectedColumns();
  }

  loadSelectedColumns(): void {
    localStorage.setItem('assign-columns', JSON.stringify(this.selectedColumns));
    this.columns = assignColumnsConfig.filter(
      (column: ColumnSettings) => !column.canBeHide || this.selectedColumns.includes(column.prop),
    );
    const packageColumnIndex = this.columns.findIndex((col) => col.name === 'Package name');
    if (packageColumnIndex > 0) {
      this.loadDefaultPackagesOptions(packageColumnIndex);
    }
  }

  toggleColumn(): void {
    this.loadSelectedColumns();
  }

  onChangeOrdersPerPage(ordersPerPage: number): void {
    this.ordersPerPage = ordersPerPage;
    this.cookieService.set('assign_orderperpage_cookie', ordersPerPage.toString());
    if (!this.shopMetadata?.addOptionPerPage || ordersPerPage !== this.shopMetadata?.addOptionPerPage) {
      this.cookieService.set('orderperpage_cookie', ordersPerPage.toString());
    }
    this.activePage = 1;
    this.getPagedOrders(0);
  }

  processOrders(data: { orders: Order[]; count: any } | any): void {
    if (data.count) {
      this.totalCountOrders = data?.count;
      this.totalPages = Math.ceil(data?.count / this.ordersPerPage);
    }
    this.utilService.setPages(this.activePage, this.allPages, this.totalPages);
    this.rows = data?.orders;
    this.rows?.forEach((row) => {
      if (row.maximalShippingHours) {
        row.maximalShippingHours = formattedServiceLevel(row);
      }
      const createdDate = row?.createdDate;
      if (createdDate) {
        const createdDateTime = new Date(createdDate).getTime();
        row.createdDateFormatted = formattedDate(row?.createdDate);
        row.time_since_ordered = this.convertToDayHour(Date.now() - createdDateTime);
      }
      if (row?.expectedDate) {
        row.expectedDateFormatted = formattedDate(row?.expectedDate);
      }

      row.inProcess = this.tableService.ordersInProcessMap.get(row.id) ?? false;
      row.formattedShippingCityAndProvince = formatShippingAddressString(row);
      row.foramttedShippingName = formatShippingNameString(row);

      if (this.shopMetadata?.isMultiParcelSupport) {
        row.box = {};
        row.box.name = formatMultiParcelBoxName(row.itemCount);
      }

      if (this.shopMetadata?.enableOrderRadiusFeature) {
        row.radius = formatOrderRadius(row, this.shopMetadata);
      }

      if (row?.customer) {
        row.customerFormated = formatBillTo(row, this.shopMetadata?.isHideEmailInBillTo);
      }
      if (row?.recommendedServiceLevelNames?.length) {
        const recommendedServiceLevelNames = Array.isArray(row.recommendedServiceLevelNames)
          ? row.recommendedServiceLevelNames
          : row.recommendedServiceLevelNames.split(',');

        row.recommendedServiceLevelNames = recommendedServiceLevelNames.map((serviceLevel) => {
          let processedServiceLevel = serviceLevel;

          // Here we handle case of PDQ International Service Levels. For some reason, we have some unclear and specific way of
          // generating service levels names, which differs from all other service levels names. Till we understand this legacy code,
          // and can fix it properly, I added this code, in order to show in table only readable chunk of service level name text
          if (serviceLevel?.split?.('|')?.length === 4) {
            processedServiceLevel = serviceLevel.split('|')[2];
          }

          return ServiceLevelToDisplayName.get(processedServiceLevel) ?? processedServiceLevel;
        });
      }

      row.deliveryPromise = getDeliveryPromise(row);

      if (row.groupBy) {
        row.groupBy = groupByValueFormatter(row.groupBy, row);
      }

      if (!row.recommendedCarrierProviders?.length && row.recommendedCarrier?.name) {
        row.recommendedCarrierProviders = row.recommendedCarrier.name;
      }
      row.currentColorTooltipString =
        !row.colorCoding || row.colorCoding.includes('transparent')
          ? ''
          : row.colorCoding
              .map((colorValue) => {
                const current = this.shop?.colorCoding?.find((colorData) => colorData.value === colorValue);
                return current?.label || current?.defaultName || '';
              })
              .join(', ');
    });

    if (this.groupBy?.length) {
      this.initGroups();
    }

    this.temp = this.rows;
    this.displayTable = true;
  }

  initGroups() {
    const groupCollapseEmpty = Object.keys(this.groupCollapseState()).length === 0;
    const groupForSort = this.groupBy[0].value;
    const firstGroup =
      groupForSort === GroupByOptions.SKU
        ? 'Multiple'
        : groupForSort === GroupByOptions.BOX
          ? 'Uncategorized'
          : 'Missing';
    this.rows.sort((a, b) => {
      return a.groupBy?.startsWith(firstGroup) ? -1 : b.groupBy?.startsWith(firstGroup) ? 1 : 0;
    });

    if (this.virtualizeGroupBy()) {
      const groupsMap = {};
      const grouped = _.groupBy(this.rows, 'groupBy');
      const groupCheckedState = {};
      Object.keys(grouped).forEach((group, index) => {
        const rows = grouped[group];
        if (rows.length) {
          groupsMap[group] = {
            key: group,
            index: index + 1,
            rows: rows,
          };
          groupCheckedState[group] = {
            checked: false,
            checkVariant: 'hyper',
          };
        }
      });
      this.groupedRowsMap.set(groupsMap);

      if (groupCollapseEmpty) {
        this.groupCollapseState.set(
          Object.fromEntries(Object.keys(this.groupedRowsMap()).map((key, index) => [key, false])),
        );
      }
      this.groupCheckedState.set(groupCheckedState);

      // Initialize all groups as visible - Intersection Observer will hide non-visible ones
      // This prevents layout thrashing on initial render
      this.groupVisibilityState.set(Object.fromEntries(Object.keys(this.groupedRowsMap()).map((key) => [key, true])));
    }
  }

  attachUpdatedRowsToGroups() {
    const currentGroups = this.groupedRowsMap();
    const newGroupedRows = _.groupBy(this.rows, 'groupBy');

    Object.keys(currentGroups).forEach((key) => {
      currentGroups[key].rows = newGroupedRows[key] || [];
    });

    this.groupedRowsMap.set({ ...currentGroups });
  }

  createQueryParameters(
    page: number,
    sortFields: SortField[] | 'NONE' = [new SortField(getDefaultSortField(this.shopService.shopPlatform), 'ASC')],
  ): QueryParameters {
    const queryParameters = new QueryParameters();
    queryParameters.page = page;
    queryParameters.maxResults = this.ordersPerPage;
    queryParameters.anyAll = 'all';
    queryParameters.filters = [new Filter('deleted', 'IN', ['0'])];
    queryParameters.stepFilter = createStepFilter(TabValueToOrderStatus[this.tabFilter] ?? OrderStatus.STEP_ASSIGN);
    queryParameters.sortFields = sortFields == 'NONE' ? undefined : sortFields;
    queryParameters.groupBy = this.groupBy.map((group) => group.value);
    return queryParameters;
  }

  createQueryPagingParameters(
    page: number,
    sortFields: SortField[] | 'NONE' = [new SortField(getDefaultSortField(this.shopService.shopPlatform), 'ASC')],
  ): QueryPagingParameters {
    const queryPagingParameters = new QueryPagingParameters();
    queryPagingParameters.filters = [new Filter('deleted', 'IN', ['0'])];
    queryPagingParameters.page = page;
    queryPagingParameters.maxResults = this.ordersPerPage;
    queryPagingParameters.sortFields = sortFields == 'NONE' ? undefined : sortFields;
    return queryPagingParameters;
  }

  paginate(page: number): void {
    this.activePage = page + 1;
    this.getPagedOrders(page);
  }

  jumpToPage(page: number): void {
    if (!page) {
      alert('Please enter a valid number');
      return;
    }

    if (page > this.totalPages) {
      alert(`Please enter a Page no. less than ${this.totalPages}`);
      return;
    }

    this.activePage = page;
    this.getPagedOrders(this.activePage - 1);
  }

  changeColorCoding({ order, colors, selectedOrders }) {
    const orderIds: string[] = selectedOrders ? this.selected.map((order) => order.id) : [order.id];
    const previousRows = this.rows;
    this.assignColorsCodingUpdate(orderIds.map((id) => ({ id, colorCoding: colors })));
    this.orderService
      .updateOrdersColorCoding(orderIds, colors)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (succededOrders) => {
          if (succededOrders && succededOrders?.length < orderIds.length) {
            const rowsToRevert = previousRows.filter(
              (row) => !succededOrders.some((succededOrder) => succededOrder.id === row.id),
            );
            this.assignColorsCodingUpdate(rowsToRevert);
          }
        },
        error: (error) => {
          this.assignColorsCodingUpdate(previousRows);
          this.toastService.showToast({
            message: `Failed to update color coding`,
            mode: 'danger',
          });
        },
      });
  }

  private assignColorsCodingUpdate(updatedOrders: Pick<Order, 'id' | 'colorCoding'>[]) {
    const newRows = assignColorCodingToRows(this.rows, updatedOrders, this.shop.colorCoding);

    this.selected = [...newRows.filter((order) => this.selected.some((o) => o.id === order.id))];

    const spOrder = this.spService.getActiveOrder();
    if (spOrder?.id) {
      const spColorCoding = updatedOrders.find((order) => order.id === spOrder?.id)?.colorCoding;
      this.spService.setActiveOrder({ ...spOrder, colorCoding: spColorCoding });
    }
    this.temp = [...newRows];
    this.rows = [...newRows];
    this.attachUpdatedRowsToGroups();
  }

  reSyncOrderClick(row, fromSidePanel?: boolean): void {
    this.isSyncing = true;
    this.setRowIsSyncing(row, true, fromSidePanel);

    this.orderService
      .syncOrder(row.id)
      .then(() => {
        this.toastService.show(PdqToastComponent, {
          message: `Order #${row.orderNumber} synced`,
          mode: 'info',
          duration: TimeUnits._SECOND_IN_MS * 3,
        });
      })
      .catch(() => {})
      .finally(() => {
        this.setRowIsSyncing(row, false, fromSidePanel);
        this.isSyncing = false;
      });
  }
  setRowIsSyncing(row, newIsSyncing: boolean, fromSidePanel?: boolean) {
    this.rows.some((listedRow, index) => {
      if (listedRow.id === row.id) {
        this.rows[index].isSyncing = newIsSyncing;
        row = { ...row, isSyncing: newIsSyncing };
        return true;
      }
      return false;
    });
    if (fromSidePanel) {
      this.spService.setActiveOrder(row);
    }
    this.temp = [...this.rows];
  }

  reSyncSelectedOrderClick(): void {
    this.isSyncing = true;
    const ordersIds = this.selected.map((order: Order) => order.id);
    this.orderService
      .syncOrders(ordersIds)
      .then((res) => {
        if (res?.unSupported) {
          this.toastService.showToast({
            message: res.unSupported,
            mode: 'danger',
          });
        } else {
          this.toastService.show(PdqToastComponent, {
            message: `${this.selected?.length} order${this.selected?.length > 1 ? 's' : ''} synced`,
            mode: 'info',
            duration: TimeUnits._SECOND_IN_MS * 3,
          });
        }
      })
      .catch(() => {
        this.toastService.showToast({
          message: `Unable to sync those orders`,
          mode: 'danger',
        });
      })
      .finally(() => {
        this.unSelectOrders();
        this.isSyncing = false;
      });
  }

  chooseEmptyMessage() {
    return this.filterActive || (this.aFilter?.length && this.isAdvancedFilters) || this.filter == 'multiple'
      ? tableMessages.NO_RESULT_MESSAGE
      : tableMessages.EMPTY_MESSAGE;
  }

  ngOnDestroy() {
    this.tableService.ordersInProcessMap?.clear();
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.freeSearchSubscription$.unsubscribe();
    this.cdr.detach();
    if (this.setAssignCountersSubscription$) {
      this.setAssignCountersSubscription$.unsubscribe();
    }
  }

  onHorizontalScroll(event: { offsetX: number }): void {
    this.tableHorizontalScrollPosition.set(event.offsetX);
  }

  resetFilters() {
    const filterFields = ['filterValue', 'filterValueStart', 'filterValueEnd', 'filterValueArray'];
    try {
      this.columns.forEach((column) => {
        filterFields.forEach((filterField) => {
          if (Object.keys(column).includes(filterField)) {
            column[filterField] = undefined;
          }
        });
      });
    } catch (e) {
      console.warn('Failed to clear table fitler fields');
    }
  }

  deselectItems() {
    this.selected = [];
    this.showAssignCarrier = false;
  }

  onBottomScrolled(onBottomScrolled: boolean): void {
    this.isBottomScrolled = onBottomScrolled;
  }

  getLabelAndCounterString(label: string, counter: number): string {
    return `${label} (${counter})`;
  }

  private initAdvancedFilters(): void {
    if (this.useCursorPagination()) {
      this.deliverCursorPagination.fetchTabCounters(this.buildTabCountersPayload());
    } else {
      this.loadCountHoldOrders();
      this.loadCountReadyOrders();
      this.loadCountScheduleOrders();
    }
    this.refreshAdvancedFilters();
    this.setAssignCounters();
    this.advancedFilterListeners();
    this.queryParamsOrderJump();
  }

  splitOrder(row) {
    this.dialog
      .open(SplitOrderComponent, {
        width: '871px',
        height: '747px',
        panelClass: 'unify-locations',
        data: row,
      })
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((isSplit) => {
        if (isSplit) {
          this.rows = [...this.rows.filter((r) => r.id !== row.id)];
        }
      });
  }

  changeLocationSelectedOrders(newLocationId: number) {
    if (this.selected.length > 9) {
      this.dialog
        .open(ChangeLocationDialogComponent, {
          width: '612px',
          height: '208px',
          panelClass: 'unify-locations',
          data: { count: this.selected.length },
        })
        .afterClosed()
        .pipe(takeUntil(this.destroyed$))
        .subscribe((isChange) => {
          if (isChange) {
            this.changeLocation(newLocationId);
          }
        });
    } else {
      this.changeLocation(newLocationId);
    }
  }

  changeLocation(newLocationId: number) {
    this.isSyncing = true;
    const ids = [];
    let countOrdersExistInLocation = 0;
    const shipFromAddress = this.shopLocations.find((l) => l.locationId === newLocationId);
    this.selected.forEach((row, index) => {
      if (row.shipFromAddress?.id === shipFromAddress.id) {
        countOrdersExistInLocation++;
      } else if (
        row.fulfillmentStatus === TranslatedFulfillmentStatus.FULFILLED ||
        row.fulfillmentStatus === TranslatedFulfillmentStatus.PARTIALLY_FULFILLED ||
        row.pickUpLocationId
      ) {
        const orderNumber = row.splitted
          ? `${row.orderNumber}${getOrderSplitIndicesString(row, 'view', true)}`
          : row.orderNumber;
        setTimeout(() => {
          this.showSnackbar(
            `Failed to change inventory location for`,
            'danger',
            {
              label: `${row.pickUpLocationId ? 'pickup' : 'fulfilled'} order #${orderNumber}`,
              variant: 'monochrome',
            },
            row.id,
          );
        }, index * 200);
      } else {
        this.setRowIsSyncing(row, true);
        ids.push(row.id);
      }
    });
    if (countOrdersExistInLocation) {
      this.showSnackbar(
        `${
          countOrdersExistInLocation < this.selected.length ? countOrdersExistInLocation + ' orders ' : ''
        }Inventory location assigned`,
        'info',
      );
    }
    if (ids.length) {
      this.isOrdersUpdating = true;
      this.disableGroupActions = true;
      this.orderService
        .changeOrdersLocation(ids, newLocationId)
        .pipe(
          catchError((error) => {
            this.endLocationChanged();
            this.showSnackbar(`Failed to change inventory locations`, 'danger');
            return of(error);
          }),
          takeUntil(this.destroyed$),
        )
        .subscribe((data) => {
          if (data && !data.error) {
            this.endLocationChanged();
            const succeededOrders = data.filter((x) => x.success);
            if (succeededOrders.length) {
              this.showSnackbar(
                `${
                  succeededOrders.length < data.length ? succeededOrders.length + ' orders ' : ''
                }Inventory location changed`,
                'info',
              );
              succeededOrders.forEach((succeededOrder) => {
                const row = this.selected.find((x) => x.id === succeededOrder.id);
                if (row) {
                  row.shipFromAddress = shipFromAddress;
                }
              });
            }
            data
              .filter((x) => !x.success)
              .forEach((x, index) => {
                const order = this.selected.find((order) => order.id === x.id);
                const orderNumber = order.splitted
                  ? `${order.orderNumber}${getOrderSplitIndicesString(order, 'view', true)}`
                  : order.orderNumber;
                setTimeout(() => {
                  this.showSnackbar(
                    x.error ? `${x.error} for` : `Failed to change inventory location for`,
                    'danger',
                    {
                      label: `order #${orderNumber}`,
                      variant: 'monochrome',
                    },
                    order.id,
                  );
                }, index * 200);
              });
          }
        });
    } else {
      this.isSyncing = false;
    }
  }

  endLocationChanged() {
    this.isSyncing = false;
    this.isOrdersUpdating = false;
    this.disableGroupActions = false;
    this.selected.forEach((row) => {
      this.setRowIsSyncing(row, false);
    });
  }

  initShortcuts() {
    this.shortCutService
      .onShortcut$(this.shortcutScope)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((shortcut) => {
        this.editPackageOrders({ shortcut });
      });
  }

  updateOrderBoxUsingShortcut(orderIds: string[], shortcut: string): void {
    if (orderIds?.length) {
      const targetBoxId = this.boxService.getBoxByShortcut(shortcut, this.shopBoxes)?.id;
      orderIds.map((id) => {
        this.tableService.ordersInProcessMap.set(id, true);
      });
      this.tableService.refreshTableOrders = orderIds.map((id) => ({ id, inProcess: true }));
      this.orderService
        .changeOrdersPackage(orderIds, targetBoxId, { emitSocketToFrontend: false })
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
          () => {
            const message = getBoxUpdateSuccessMessage(orderIds.length);
            this.showSnackbar(message, 'success');
          },
          (error) => {
            const message = getBoxUpdateFailureMessage(orderIds.length);
            this.tableService.ordersInProcessMap.clear();
            this.tableService.refreshTableOrders = orderIds.map((id) => ({ id, inProcess: false }));
            this.showSnackbar(message, 'danger');
          },
        );
    }
  }

  editPackageOrders(options: { shortcut?: string } = {}) {
    if (this.selected.length > 500) {
      this.showSnackbar('you can’t modified more than 500 orders', 'danger');
    } else if (options?.shortcut) {
      this.updateOrderBoxUsingShortcut(
        this.selected.map((order) => order.id),
        options.shortcut,
      );
    } else {
      const dialogRef = this.dialog.open(EditOrderPackageComponent, {
        backdropClass: 'global_modal_overlay_subdued',
        panelClass: 'overflow-visible-class',
        data: {
          initialWeight: { weight: 0, weightUnit: WeightUnitEnum.LB },
          shopBoxes: this.shopBoxes,
          orderIds: this.selected.map((order) => order.id),
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroyed$))
        .subscribe((success) => {
          if (success) {
            this.selected = [];
            this.showAssignCarrier = false;
          }
        });
    }
  }

  mergeOrders() {
    this.dialog
      .open(MergeOrdersComponent, {
        width: '612px',
        backdropClass: 'global_modal_overlay_subdued',
        panelClass: 'overflow-visible-class',
        data: this.selected,
      })
      .afterClosed()
      .subscribe((success) => {
        if (success) {
          this.showSnackbar(`${this.selected.length} orders merged`, 'info');
        } else if (success == false) {
          this.showSnackbar('Failed to merge orders. Try again or reach out to support', 'danger');
        }
        this.unSelectOrders();
      });
  }

  showSnackbar(message, mode: 'danger' | 'success' | 'info' | 'secondary', link?, orderId?: number) {
    const toastRef = this.toastService.show(PdqToastComponent, {
      mode,
      message,
      link,
      duration: TimeUnits._SECOND_IN_MS * 5,
    });
    if (orderId) {
      toastRef.componentInstance.onAction.pipe(takeUntil(this.destroyed$)).subscribe(() => {
        const row = { id: orderId };
        this.onTableActivate({ row });
      });
    }
  }

  groupChanged(groups: DropdownOption[]) {
    if (
      groups.length !== this.groupBy.length ||
      groups.find((o1, index1) => groups[index1].value !== this.groupBy[index1]?.value)
    ) {
      this.groupBy = groups;
      this.searchAutocompleteRef?.resetFormControl();
      this.unSelectOrders();
      this.filter = FilterTypes.READY;
      this.aFilter = null;
      this.isAdvancedFilters = false;
      this.groupedRowsMap.set({});
      this.groupVisibilityState.set({});
      this.activePage = 1;
      this.groupByPaginationOptions(!!this.groupBy?.length);
      this.getPagedOrders(0);
      //ngx-datatable listner init only onInit the table component else there is a bug onDestroy
      this.displayTable = false;
      if (groups.length) {
        if (this.setAssignCountersSubscription$) {
          this.setAssignCountersSubscription$.unsubscribe();
          this.setAssignCountersSubscription$ = null;
        }
      } else {
        this.setAssignCounters();
      }
    }
  }

  groupByPaginationOptions(isActive: boolean) {
    const groupByMaxResults = this.shop?.metadata?.groupByMaxResults ?? GROUP_BY_MAX_RESULTS;
    this.ordersPerPage = isActive && this.ordersPerPage > groupByMaxResults ? groupByMaxResults : this.ordersPerPage;
    const perPageOptions = this.perPageOptions.filter((option) => option.value <= groupByMaxResults);
    this.perPageOptions = isActive ? [...perPageOptions] : [...PaginationOptionsDisplay];
  }

  closeSidePanel(drawer) {
    drawer.close();
  }

  onSidePanelClosed(opened: boolean) {
    if (!opened && this.isPickingMode) {
      this.searchAutocompleteRef?.resetFormControl();
      // this.searchAutocompleteRef?.focusSearchField();
    }
  }

  addTagSelectedOrders() {
    this.dialog
      .open(AddTagsComponent, {
        width: '612px',
        height: '300px',
        panelClass: 'unify-locations',
        disableClose: true,
        data: { orders: this.selected, shopId: this.shopId },
      })
      .afterClosed();
    // .subscribe(() => {
    //   this.selected = [];
    // });
  }

  onCursorPageChange(action: PaginationCursorAction): void {
    this.pullOrdersByCursor(action);
  }

  private getCappedCounterLabel(label: string, counterKey: keyof DeliverCursorPagination.AssignTabCounters): string {
    const tabCounters = this.deliverCursorPagination.tabCounters();
    if (!tabCounters) return label;
    return `${label} (${this.deliverCursorPagination.formatCappedCount(tabCounters[counterKey])})`;
  }

  private refreshCurrentPage(): void {
    if (this.useCursorPagination()) {
      this.pullOrdersByCursor('current');
      return;
    }

    this.getPagedOrders(this.activePage - 1);
  }

  private pullOrdersByCursor(action: PaginationCursorAction = 'first', toOpenSidePanel: boolean = false): void {
    this.loading = true;
    const query = this.buildCursorQuery();

    this.deliverCursorPagination
      .fetchOrders(action, query, this.ordersPerPage)
      .pipe(
        takeUntil(this.destroyed$),
        finalize(() => {
          this.loading = false;
          this.isLoadedInitialData = true;
          this.updateTabActionFlags();
        }),
        tap((orders) => this.openSidePanelForSingleOrder(orders, toOpenSidePanel)),
      )
      .subscribe((orders) => {
        const totalCount = this.deliverCursorPagination.totalCount();
        this.processOrders({ orders, count: totalCount?.count ?? orders.length });
      });

    if (action === 'first' || action === 'current') {
      this.deliverCursorPagination.fetchTotalCount(query);
    }
  }

  private updateTabActionFlags(): void {
    this.notshow = true;
    this.unhold = false;
    this.unschedule = false;

    switch (this.filter) {
      case FilterTypes.SCHEDULE: {
        this.groupBy = [];
        this.groupedRowsMap.set({});
        this.groupVisibilityState.set({});
        this.notshow = false;
        this.unschedule = true;
        break;
      }
      case FilterTypes.HOLD: {
        this.groupBy = [];
        this.groupedRowsMap.set({});
        this.groupVisibilityState.set({});
        this.notshow = false;
        this.unhold = true;
        break;
      }
    }
  }

  private openSidePanelForSingleOrder(orders: Order[], toOpenSidePanel: boolean): void {
    if (this.isPickingMode && toOpenSidePanel && orders.length === 1) {
      this.spService.setFocusedOrderId(orders[0].id, {
        sectionId: SidePanelSection.ORDER_ITEMS_WRAPPER,
        data: { action: 'edit' },
      });
    }
  }

  private buildCursorQuery(): QueryParameters {
    const query = this.sortFields?.length
      ? this.createQueryParameters(0, this.sortFields)
      : this.createQueryParameters(0);

    if (this.tableFilters?.length) {
      query.filters = [...(query.filters ?? []), ...this.tableFilters];
    }

    switch (this.filter) {
      case FilterTypes.QUERY_PARAMS: {
        query.filters = [new Filter('order.id', 'EQUAL', [this.orderIdSearchParams])];
        query.stepFilter = undefined;
        break;
      }
      case FilterTypes.FREE_SEARCH: {
        query.filters = [this.getFreeSearchFilter()];
        break;
      }
      case FilterTypes.FREE_TEXT: {
        query.search = this.freeSearchValue;
        break;
      }
      case FilterTypes.MULTIPLE: {
        query.filters = [new Filter(this.freeSearchSelectedField, 'IN', this.freeSearchValue)];
        break;
      }
    }

    if (this.mentionsFilter?.length) {
      query.mentionsFilter = new Filter('teamNotes.userCollaboration', 'IN', this.mentionsFilter);
    }

    if (this.isAdvancedFilters && this.aFilter?.length) {
      query.advancedFilterIds = this.aFilter.map((f) => String(f.id));
    }

    return query;
  }

  private buildTabCountersPayload(): DeliverCursorPagination.AssignTabCountersPayload | undefined {
    const filters = this.tableFilters?.length ? this.tableFilters : undefined;
    const advancedFilterIds =
      this.isAdvancedFilters && this.aFilter?.length ? this.aFilter.map((f) => String(f.id)) : undefined;
    if (!filters && !advancedFilterIds) return undefined;
    return { filters, advancedFilterIds };
  }
}
